
import React,{useState} from 'react'
import ClinicOverview from "./ClinicOverview";
import HoursOfOperation from "../hourstab/HoursOfOperation";
import AddressCard from './AddressCard';
import TimeZoneCard from './TimeZoneCard';
import LogoCard from './LogoCard';
import AssetsCard from './AssetsCard';
const InfoTab = () => {
    const [clinicLogo,setClinicLogo] = useState()

    const updateLogo = (logourl)=>{
        console.log(logourl)
        setClinicLogo(logourl)
    }
    return ( 
        <>
          
               
                <div className="container">
                    <div className="row">
                        <div className="col-7 d-flex flex-column">
                            <ClinicOverview updateLogo={updateLogo}/>
                            <AssetsCard/>
                        </div>
                        <div className="col-5">
                        <div className='d-flex flex-column'>
                        <AddressCard/>
                        <TimeZoneCard/>
                        <LogoCard logoUrl = {clinicLogo}/>
                        </div>
                      
                        </div>
                    </div>
                </div>
                    
                  
            
                
                  
                 
        </>
     );
}
 
export default InfoTab;